import { REQUEST_DELAY } from "@/constants";

export class Mock {
  login({ email = "" }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          ok: true,
          result: {
            success: true,
            usuario: [
              {
                _id: "5a95d30189260731cb1b2c11",
                multiples_mesas: true,
                check_mesas: [
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 1,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 2,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 3,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 4,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 5,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 6,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 7,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 8,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 9,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 10,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 11,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 12,
                  },
                  {
                    E14_sen: true,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: true,
                    reclamaciones_sen: false,
                    E14_cam: true,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: true,
                    mesa: 13,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 14,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 15,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 16,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 17,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 18,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 19,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 20,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 21,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 22,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 23,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 24,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 25,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 26,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 27,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 28,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 29,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 30,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 31,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 32,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 33,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 34,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 35,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 36,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 37,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 38,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 39,
                  },
                  {
                    E14_sen: false,
                    cuenta_votos_sen: false,
                    ingreso_datos_sen: false,
                    reclamaciones_sen: false,
                    E14_cam: false,
                    cuenta_votos_cam: false,
                    ingreso_datos_cam: false,
                    reclamaciones_cam: false,
                    mesa: 40,
                  },
                ],
                documento: "9999999",
                nombre: "Maria Clara de Herrera",
                email: "mariacmoore72@gmail.com",
                clave:
                  "$2a$10$uKHXsa44lCrYKIf4ezrtCOKp23snXicUJNdH3Ce0nJGWs7cpypPSK",
                celular: "9544807144",
                puesto: "Miami - Consulado",
                mesa: 13,
                puesto_id: "5a947133c20f8eb928ff83ec",
                admin: true,
                create_date: "2018-02-27T21:52:01.743Z",
                __v: 0,
              },
            ],
          },
        });
      }, REQUEST_DELAY);
    });
  }
  logout() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ ok: true });
      }, REQUEST_DELAY);
    });
  }
  uploadFile() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ ok: true });
      }, REQUEST_DELAY);
    });
  }
}
